import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
        InnerBlocks,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        SelectControl,
        Button
    } = window.wp.components;

    registerBlockType('custom-gutenberg/special-offer', {
        // built-in attributes
        title: 'Special Offer',
        description: 'Custom Special Offer',
        icon: '',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            target: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
            badgeText: {
                type: 'string',
                default: 'Up to'
            },
            badgePercent: {
                type: 'string',
                default: ''
            },
            buttonText: {
                type: 'string',
                default: 'Discover offer'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                link,
                target,
                image,
                alt,
                badgeText,
                badgePercent,
                buttonText,
                classes
            } = attributes;

            const MY_TEMPLATE = [
                [ 'core/heading', { placeholder: 'Card title', className: 'card-subtitle', level: 6 } ],
                [ 'core/heading', { placeholder: 'Card title', className: 'card-title', level: 4 } ],
                [ 'core/paragraph', { placeholder: 'Card text', className: 'card-description' } ]
            ];

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onTargetChange (target) {
                setAttributes({target: target});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
                setAttributes({alt: image.alt});
            };

            function onBadgeTextChange (badgeText) {
                setAttributes({badgeText: badgeText});
            };

            function onBadgePercentChange (badgePercent) {
                setAttributes({badgePercent: badgePercent});
            };

            function onButtonTextChange (buttonText) {
                setAttributes({buttonText: buttonText});
            };

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <div>
                                    { image && 
                                        <div>
                                            <figure>
                                                <img src={image} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ image: '' })} className="button">Remove</Button>
                                            </div>
                                            <br></br>
                                        </div>
                                
                                    }
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                                </div>
                            ) } />
                        <br />
                        <p><strong>Enter url: (ex: /en/villas/)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br></br>
                        <p class="mb-0"><strong>Url target:</strong></p>
                        <SelectControl value={ target } onChange={ onTargetChange } options={ [
                            { label: '', value: '' },
                            { label: '_blank', value: '_blank' },
                            { label: '_self', value: '_self' },
                            { label: '_parent', value: '_parent' },
                            { label: '_top', value: '_top' },
                        ] } />
                        <br />
                        <p><strong>Badge text</strong></p>
                        <TextControl value={ badgeText } onChange={ onBadgeTextChange }></TextControl>
                        <br />
                        <p><strong>Badge percent</strong></p>
                        <TextControl value={ badgePercent } onChange={ onBadgePercentChange }></TextControl>
                        <br />
                        <p><strong>Button text</strong></p>
                        <TextControl value={ buttonText } onChange={ onButtonTextChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <div className={ "card card-special-offer" + (classes ? ' ' + classes : '') }>
                    <div className="card-img-top">
                        <img className="cover-image" src={ image } alt={ alt } />
                        <div className="badge-percent">
                            <div className="text">{ badgeText }</div>
                            <div className="percent">{ badgePercent }</div>
                        </div>
                    </div>
                    <div className="card-body">
                        <InnerBlocks template={ MY_TEMPLATE } />
                        <a className="btn btn-primary">{ buttonText }</a>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                target,
                image,
                alt,
                badgeText,
                badgePercent,
                buttonText,
                classes
            } = attributes;

            return (
                <div className={ "card card-special-offer" + (classes ? ' ' + classes : '') }>
                    <div className="card-img-top">
                        <img className="lozad cover-image" data-src={ image } alt={ alt } />
                        <div className="badge-percent">
                            <div className="text">{ badgeText }</div>
                            <div className="percent">{ badgePercent }</div>
                        </div>
                    </div>
                    <div className="card-body">
                        <InnerBlocks.Content />
                        <a href={ link } target={ target } className="btn btn-primary">{ buttonText }</a>
                    </div>
                </div>
            );
        },
    });
}